import React from 'react';
import PropTypes from 'prop-types';
import { getOverlayPointsLimitMessage } from 'common/constants';
import OverlayNoteBox from 'common/components/atoms/OverlayNoteBox';
import AnnotationsList from 'home/Annotations/components/AnnotationsList';

const ChartsViewOverlays = (props) => {
  const {
    t,
    annotationsVisible,
    chartType,
    showCharts,
    getTimeRangeForAnnotations,
    tag,
    config,
    showOverlayNote,
    handleOverlayMessageDismiss
  } = props;

  return (
    <>
      {annotationsVisible &&
        chartType === 'trend' &&
        showCharts &&
        getTimeRangeForAnnotations() &&
        tag &&
        tag.id &&
        (config &&
          config.trends_data &&
          Array.isArray(config.trends_data) &&
          config.trends_data.length > 0) && (
            <AnnotationsList
              entityType="tag"
              entityId={tag.id}
              timeRange={getTimeRangeForAnnotations()}
            />
      )}
      <OverlayNoteBox
        show={showOverlayNote}
        message={getOverlayPointsLimitMessage(t)}
        autoDismissTime={10000}
        showDontShowAgain
        onDismiss={handleOverlayMessageDismiss}
      />
    </>
  );
};

/* eslint-disable react/require-default-props */
ChartsViewOverlays.propTypes = {
  t: PropTypes.func,
  annotationsVisible: PropTypes.bool,
  chartType: PropTypes.string,
  showCharts: PropTypes.bool,
  getTimeRangeForAnnotations: PropTypes.func,
  tag: PropTypes.object,
  config: PropTypes.object,
  showOverlayNote: PropTypes.bool,
  handleOverlayMessageDismiss: PropTypes.func
};

export default ChartsViewOverlays;
